import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../firebase';
import { info, warn } from '../utils/logger';

export type QuoteWatchlistItem = {
    symbol: string;
    lastSeenAt: unknown;
    addedAt?: unknown;
    name?: string;
    exchange?: string;
    currency?: string;
    assetType?: 'equity' | 'etf' | 'crypto' | 'fx' | 'index';
    region?: string;
    provider?: string;
    pinned?: boolean;
    notes?: string;
};

export const useQuoteWatchlist = () => {
    const [watchlist, setWatchlist] = useState<QuoteWatchlistItem[]>([]);

    useEffect(() => {
        let unsubscribeSnapshot: (() => void) | undefined;
        const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
            if (unsubscribeSnapshot) {
                unsubscribeSnapshot();
                unsubscribeSnapshot = undefined;
            }

            if (!user) {
                setWatchlist([]);
                return;
            }

            const watchlistCollection = collection(db, 'users', user.uid, 'watchlist');
            const watchlistQuery = query(watchlistCollection, orderBy('lastSeenAt', 'desc'));

            unsubscribeSnapshot = onSnapshot(
                watchlistQuery,
                (snapshot) => {
                    const data = snapshot.docs.map(
                        (doc) =>
                            ({
                                ...doc.data(),
                            } as QuoteWatchlistItem)
                    );
                    info('[useQuoteWatchlist] watchlist updated', { count: data.length });
                    setWatchlist(data);
                },
                (error) => {
                    warn('[useQuoteWatchlist] watchlist snapshot failed', { error, userId: user.uid });
                }
            );
        });

        return () => {
            if (unsubscribeSnapshot) {
                unsubscribeSnapshot();
            }
            unsubscribeAuth();
        };
    }, []);

    return watchlist;
};
